import { render, staticRenderFns } from "./CommCdDescModal.vue?vue&type=template&id=c9d94a5a&"
import script from "./CommCdDescModal.vue?vue&type=script&lang=js&"
export * from "./CommCdDescModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports